import { render, staticRenderFns } from "./personal-details.html?vue&type=template&id=5c6c64be&scoped=true&"
import script from "./personal-details.js?vue&type=script&lang=js&"
export * from "./personal-details.js?vue&type=script&lang=js&"
import style0 from "./personal-details.scss?vue&type=style&index=0&id=5c6c64be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6c64be",
  null
  
)

export default component.exports